const getters = {
  types: state => state.types,
  typeById: state => id => {
    let deviceType = state.types.find(deviceType => deviceType.id === Number(id));
    return deviceType ? deviceType : state.unknownType
  },
};

export default getters;
